function isValidDate(date: Date): boolean {
	return !isNaN(date.valueOf());
}

function dateToString(date?: Date | string | null): string {
	if (!date) {
		return '';
	}

	const parsedDate = typeof date === 'string' ? new Date(date) : date;
	if (!isValidDate(parsedDate)) {
		return '';
	}

	return parsedDate.toLocaleDateString('en-US', {
		month: 'long',
		day: 'numeric',
		year: 'numeric'
	});
}

function isDateInFuture(date?: Date | string | null): boolean {
	if (!date) {
		return false;
	}

	const parsedDate = typeof date === 'string' ? new Date(date) : date;
	const now = new Date();

	if (!isValidDate(parsedDate)) return false;

	return parsedDate > now;
}

function isDateInPast(date?: Date | string | null, comparedToDate: Date = new Date()): boolean {
	if (!date) {
		return false;
	}

	const parsedDate = typeof date === 'string' ? new Date(date) : date;

	if (!isValidDate(parsedDate)) return false;

	return parsedDate < comparedToDate;
}

function getTimeInSecond({
	ms,
	s,
	min,
	h,
	d,
	w,
	m,
	y
}: {
	ms?: number;
	s?: number;
	min?: number;
	h?: number;
	d?: number;
	w?: number;
	m?: number;
	y?: number;
}) {
	return (
		(ms || 0) / 1e3 +
		(s || 0) +
		(min || 0) * 60 +
		(h || 0) * 3600 +
		(w || 0) * 604800 +
		(d || 0) * 86400 +
		(m || 0) * 2592e3 +
		(y || 0) * 31536e3
	);
}

/**
 * trigger a callback at a specific date
 * @param targetDate the date to trigger the callback
 * @param callback the callback to trigger
 */
function runAtDate(targetDate: Date, callback: () => void, timeoutId?: string): void {
	const now = Date.now();
	const timeUntilTarget = targetDate.getTime() - now;

	if (timeUntilTarget > 0 && !doesTimeoutOverflow(timeUntilTarget)) {
		if (timeoutId) {
			// @ts-ignore
			!!window[timeoutId] && clearTimeout(window[timeoutId]);
			// @ts-ignore
			window[timeoutId] = setTimeout(callback, timeUntilTarget);
			return;
		}

		setTimeout(callback, timeUntilTarget);
	}
}

/**
 * Checks if the input value in milliseconds overflows the maximum value for setTimeout.
 * The maximum value for setTimeout is determined by the maximum value of a signed 32-bit integer,
 * which is 2147483647 milliseconds or about 24.8 days.
 *
 * @param {number} milliseconds - The input value in milliseconds to check.
 * @returns {boolean} - Returns true if the input value overflows the maximum value for setTimeout, false otherwise.
 */
function doesTimeoutOverflow(milliseconds: number): boolean {
	const maxTimeout = 2147483647;
	return milliseconds > maxTimeout;
}

export { dateToString, doesTimeoutOverflow, getTimeInSecond, isDateInFuture, isDateInPast, runAtDate };
